import { Action, createReducer, on } from '@ngrx/store';
import { ClearAuthToken, SetAuthToken } from '../actions';
import {
  clearAuthSession,
  getStoredAuthToken,
  getStoredUserType,
  saveAuthSession,
} from '@libraries/helpers';

export interface RootState {
  loaded: boolean;
  loading: boolean;
  authToken?: string;
  userType?: string;
}

const initialAuthToken = getStoredAuthToken() || undefined;
const initialUserType = getStoredUserType() || undefined;

export const initialRootState: RootState = {
  loaded: false,
  loading: false,
  authToken: initialAuthToken,
  userType: initialUserType,
};

const reducer = createReducer(
  initialRootState,
  on(SetAuthToken, (state, { authToken, userType }) => {
    const resolvedUserType = userType !== undefined ? userType : state.userType;
    saveAuthSession(authToken, resolvedUserType);
    return {
      ...state,
      authToken,
      userType: resolvedUserType,
    };
  }),
  on(ClearAuthToken, (state) => {
    clearAuthSession();
    return {
      ...state,
      authToken: undefined,
      userType: undefined,
    };
  })
);

export function appReducer(state: RootState | undefined, action: Action) {
  return reducer(state, action);
}
